import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD,
  ITEMS_TYPE_SIMILAR
} from "../../constants";
import itemsTypeCustomerItems from "./itemsTypeCustomerItems";
import itemsTypeSharedBoard from "./itemsTypeSharedBoard";
import itemsTypeSimilarItems from "./itemsTypeSimilarItems";

const reducerMap = {
  [ITEMS_TYPE_CUSTOMER_ITEMS]: itemsTypeCustomerItems,
  [ITEMS_TYPE_SHARED_BOARD]: itemsTypeSharedBoard,
  [ITEMS_TYPE_SIMILAR]: itemsTypeSimilarItems
};

export const setItemsType = (state, { payload: { itemsType } }) => ({
  ...reducerMap[itemsType](state),
  itemsType
});
